<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Raw Material Requisition Receive List
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-card class="pa-4">

                  <v-data-table
                    :headers="headers"
                    :items="getRawMetarialRequisitionReceiveList"
                    item-value="id"
                    class="elevation-1"
                  >

                    <!-- Serial -->
                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <!-- Status -->
                    <template #item.status="{ item }">
                      <v-chip
                        v-if="item.approval_status == 'Approved'"
                        color="success"
                        size="small"
                      >
                        Approved
                      </v-chip>

                      <v-chip v-else color="red" size="small">
                        Pending
                      </v-chip>
                    </template>

                    <!-- Actions -->
                    <template #item.actions="{ item }">

                      <!-- View -->
                      <v-icon
                        small
                        class="me-2 edit-button"
                        color="blue"
                        title="View Details"
                        @click="viewDetails(item)"
                      >
                        mdi-file-document-outline
                      </v-icon>

                      <!-- Edit -->
                      <v-icon
                        class="me-2 edit-button"
                        color="primary"
                        @click="editItem(item)"
                      >
                        mdi-pencil-outline
                      </v-icon>

                    </template>

                  </v-data-table>

                </v-card>
              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"

const store = useStore()
const router = useRouter()

/* -----------------------------
STATE
--------------------------------*/
const panel = ref([0])

/* -----------------------------
TABLE HEADERS
--------------------------------*/
const headers = [
  { title: "#SL", key: "index" },
  { title: "Code", key: "code" },
  { title: "Receive Date", key: "receive_date" },
  { title: "Approval Status", key: "status" },
  { title: "Actions", key: "actions" }
]

/* -----------------------------
GETTERS
--------------------------------*/
const getRawMetarialRequisitionReceiveList = computed(() => {
  return store.getters.getRawMetarialRequisitionReceiveList
})

/* -----------------------------
LOAD DATA
--------------------------------*/
const loadData = async () => {
  await store.dispatch("getRawMetarialRequisitionReceiveList")
}

/* -----------------------------
ACTIONS
--------------------------------*/
function editItem(item) {
  router.push({
    name: "create-requisition-receive",
    query: { id: item.id }
  })
}

function viewDetails(item) {
  router.push({
    name: "production-requisition-receive-details",
    params: { id: item.id }
  })
}

/* -----------------------------
MOUNT
--------------------------------*/
onMounted(() => {
  loadData()
})
</script>